// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3QdaC","content":"GlobalSearch_content__L7Uq6"};